const baseURL = window.location.origin;

export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const APP_ENV = import.meta.env.VITE_APP_ENV;
const appHost = window.location.hostname.toLowerCase();
export const IS_UAT_ENV =
  APP_ENV?.toLowerCase() === 'uat' || appHost.startsWith('uat.') || appHost.includes('.uat.');
export const APP_URL = `${baseURL}`; //import.meta.env.VITE_APP_URL;

export const GOOGLE_REDIRECT_URL = `${baseURL}`; //import.meta.env.VITE_GOOGLE_REDIRECT_URL;
export const AUTH_CALLBACK_URL = `${baseURL}/auth-callback`; //import.meta.env.VITE_AUTH_CALLBACK_URL;

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_CLIENT_ID;
export const GOOGLE_CLIENT_SECRET = import.meta.env.VITE_GOOGLE_CLIENT_SECRET;
export const GOOGLE_AD_CLIENT_ID = import.meta.env.VITE_GOOGLE_AD_CLIENT_ID;
export const GOOGLE_AD_CLIENT_SECRET = import.meta.env
  .VITE_GOOGLE_AD_CLIENT_SECRET;
export const META_APP_ID = import.meta.env.VITE_META_APP_ID;
export const META_CONFIG_ID = import.meta.env.VITE_META_CONFIG_ID;
export const TIKTOK_APP_ID = import.meta.env.VITE_TIKTOK_APP_ID;
export const TIKTOK_SECRET = import.meta.env.VITE_TIKTOK_SECRET;
export const AMAZON_CLIENT_ID = import.meta.env.VITE_AMAZON_CLIENT_ID;
export const STRIPE_PUBLISHABLE_KEY = import.meta.env
  .VITE_STRIPE_PUBLISHABLE_KEY;
export const STRIPE_PRICING_TABLE_ID = import.meta.env
  .VITE_STRIPE_PRICING_TABLE_ID;
export const hidePages = import.meta.env.VITE_HIDE_PAGES?.split(',') || [];
export const LINKEDIN_CLIENT_ID = import.meta.env.VITE_LINKEDIN_CLIENT_ID;
export const HUBSPOT_CLIENT_ID = import.meta.env.VITE_HUBSPOT_CLIENT_ID;
export const REDDIT_CLIENT_ID = import.meta.env.VITE_REDDIT_CLIENT_ID;
export const BING_ADS_CLIENT_ID = import.meta.env.VITE_BING_ADS_CLIENT_ID;
export const SHOPIFY_CLIENT_ID = import.meta.env.VITE_SHOPIFY_CLIENT_ID;
export const GOHIGHLEVEL_CLIENT_ID = import.meta.env.VITE_GOHIGHLEVEL_CLIENT_ID;
export const SLACK_CLIENT_ID = import.meta.env.VITE_SLACK_CLIENT_ID;

// Cognito federated login configuration
export const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN;
export const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID;
export const COGNITO_CALLBACK_URL = import.meta.env.VITE_COGNITO_CALLBACK_URL;
export const COGNITO_LOGOUT_URL = import.meta.env.VITE_COGNITO_LOGOUT_URL;

export const DSN = import.meta.env.VITE_SENTRY_DSN;
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const IS_SENTRY_DISABLED = import.meta.env.VITE_IS_SENTRY_DISABLED;

export const POSTHOG_KEY =
  import.meta.env.VITE_POSTHOG_KEY || import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
export const POSTHOG_HOST =
  import.meta.env.VITE_POSTHOG_HOST ||
  import.meta.env.VITE_PUBLIC_POSTHOG_HOST ||
  'https://us.i.posthog.com';
export const FEATURES = {
  DIRECT_S3_UPLOAD: import.meta.env.VITE_DIRECT_S3_UPLOAD == 'true' || false,
};

export const IS_ANONYMOUS_APP = import.meta.env.VITE_IS_ANONYMOUS_APP === 'true';

/** Signup URL for the main app. On the main app this is same-origin (baseURL); on the demo app we use env or default. */
const mainAppOrigin = IS_ANONYMOUS_APP
  ? (import.meta.env.VITE_MAIN_APP_URL ||
      (typeof window !== 'undefined' && window.location.hostname === 'localhost'
        ? 'http://localhost:3000'
        : 'https://leonardo.fibonaccipartner.com'))
  : baseURL;
export const MAIN_APP_SIGNUP_URL = `${mainAppOrigin.replace(/\/$/, '')}/auth/signup`;

/** Where to send users when they log out from the demo app (marketing/landing site). */
const defaultLandingUrl =
  typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:4321'
    : 'https://www.leoads.ai';
export const LANDING_PAGE_URL =
  import.meta.env.VITE_LANDING_PAGE_URL || defaultLandingUrl;

export const DEFAULT_BRANDING_COMPANY_NAME =
  import.meta.env.VITE_DEFAULT_BRANDING_COMPANY_NAME || 'fibonaccidev';

export const DISABLE_BILLING_PAGE_FOR_COMPANIES =
  import.meta.env.VITE_DISABLE_BILLING_PAGE_FOR_COMPANIES?.split(',') || [];

// Maintenance banner configuration
export const MAINTENANCE_ENABLED =
  import.meta.env.VITE_MAINTENANCE_ENABLED === 'true';
export const MAINTENANCE_START = import.meta.env.VITE_MAINTENANCE_START || '';
export const MAINTENANCE_END = import.meta.env.VITE_MAINTENANCE_END || '';

// Environment variables debugging - only in development
if (typeof window !== 'undefined' && APP_ENV === 'development') {
  const logEnvVars = () => {
    console.group('🔧 Environment Variables Debug (Dev Only)');
    console.log('API_BASE_URL:', API_BASE_URL);
    console.log('APP_ENV:', APP_ENV);
    // Client IDs are public but limit logging in production
    console.log('META_APP_ID:', META_APP_ID ? '***SET***' : 'undefined');
    console.log('META_CONFIG_ID:', META_CONFIG_ID ? '***SET***' : 'undefined');
    console.log('LINKEDIN_CLIENT_ID:', LINKEDIN_CLIENT_ID ? '***SET***' : 'undefined');
    console.log('TIKTOK_APP_ID:', TIKTOK_APP_ID ? '***SET***' : 'undefined');
    console.log('GOOGLE_CLIENT_ID:', GOOGLE_CLIENT_ID ? '***SET***' : 'undefined');
    console.log('AMAZON_CLIENT_ID:', AMAZON_CLIENT_ID ? '***SET***' : 'undefined');
    console.log('HUBSPOT_CLIENT_ID:', HUBSPOT_CLIENT_ID ? '***SET***' : 'undefined');
    console.log('REDDIT_CLIENT_ID:', REDDIT_CLIENT_ID ? '***SET***' : 'undefined');
    console.log('SHOPIFY_CLIENT_ID:', SHOPIFY_CLIENT_ID ? '***SET***' : 'undefined');
    console.log('STRIPE_PUBLISHABLE_KEY:', STRIPE_PUBLISHABLE_KEY ? '***SET***' : 'undefined');
    console.log('SENTRY_DSN:', SENTRY_DSN ? '***SET***' : 'undefined');
    console.groupEnd();
  };
  // Log immediately and then every 10 seconds (only in dev)
  logEnvVars();
  setInterval(logEnvVars, 10000);
}